import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'accountFilter'})
export class AccountFilter implements PipeTransform {
    transform(array: any[], active: boolean, projectFilter: string, employerFilter: string ): any[] {
        if (array) {
            return array.filter(account => {
                let result = true;
                result = !active || account.active || false;
                if (result) {
                    if (projectFilter && projectFilter !== 'undefined') {
                        result = account.project_ids.filter(id => {return id === projectFilter; }).length > 0;
                    }
                    if (result) {
                      if (employerFilter && employerFilter !== 'undefined') {
                        result = account.company_id === employerFilter;
                      }
                    }
                }
                return result;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounts/accounts.filter.ts